import "@styles/globals.scss";
import config from "@utils/config";
import type { AppProps } from "next/app";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
import routeStore from "@utils/routeStore";
import _ from "lodash";
import {
  hasConsentChoice,
  getConsentState,
  updateGoogleConsentMode,
} from "@utils/cookieConsent";

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    if (!config.GTM_ID) return;
    const consent = getConsentState();
    const hasChoice = hasConsentChoice();
    if (hasChoice && (consent.analytics || consent.marketing)) {
      TagManager.initialize({ gtmId: config.GTM_ID });
      updateGoogleConsentMode(consent);
    }
  }, []);
  routeStore.hotel = _.get(pageProps, "hotel", "");
  return <Component {...pageProps} />;
}

export default MyApp;
